import React, { useEffect } from 'react';
import Sidebar from './Sidebar';
import styles from './Layout.module.css';
import { useCategoryTree } from '../../hooks/useCategoryTree';
import { reportAppError } from '../../utils/errorReport';
import { CpaProvider } from '../../context/CpaContext';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { error: categoryTreeError } = useCategoryTree();

  useEffect(() => {
    if (categoryTreeError) {
      reportAppError('שגיאה בטעינת עץ הקטגוריות', {
        action: 'Load category tree',
        error: categoryTreeError,
      });
    }
  }, [categoryTreeError]);

  return (
    <CpaProvider>
    <div className={styles.layout}>
      <Sidebar />
      <main className={styles.mainContent}>
        {children}
      </main>
    </div>
    </CpaProvider>
  );
};

export default Layout; 